import { Illustration } from 'modules/common/components/Illustrations/Illustration'
import { useTranslation } from 'modules/common/hooks/useTranslation'

export const FileComplaintFormSuccessModalContent = () => {
  const { t } = useTranslation('common-components')

  return (
    <div className="flex flex-col items-center gap-4">
      <Illustration name="check" size="l" />
      <h2>{t('fileComplaintFormSuccessModal.title')}</h2>
      <p>{t('fileComplaintFormSuccessModal.text')}</p>
    </div>
  )
}
